
// UTILS
import {init as initUtils } from './../framework/utils';

// TRACKERS - Commons
import { init as initHeader } from './../trackers/commons/header-tracker';
import { init as initFooter } from './../trackers/commons/footer-tracker';
import { init as initFilters } from './../trackers/commons/filters-tracker';
// import { init as initNavigation } from './../trackers/commons/navigation-tracker';
import { init as initSearch } from './../trackers/commons/search-tracker';
import { init as initSuggestions } from './../trackers/commons/suggestions-tracker';
import { init as initLvpHistory } from './../trackers/customer/lvp-history-tracker';
import {init as initSmartSuggest} from './../trackers/commons/smart-suggest-tracker';

// TRACKERS - Sports Page
import { init as initSportPage } from './../trackers/sportpage/sportpage-tracker';

// TRACKERS - Checkout
import { init as initExpressCheckout } from './../trackers/funnel/express-checkout-tracker';

// // SHOPPING TOOL
import { init as initStAddToCart } from './../shopping-tool/st-add-to-cart';
import { init as initStNavigation } from './../shopping-tool/st-navigation';
import { init as initStBreadcrumb } from './../shopping-tool/st-breadcrumb';
import { init as initStOpeco } from './../shopping-tool/st-opeco';
import { init as initStInternalSearch } from './../shopping-tool/st-internal-search';

// ENHANCED E-COMMERCE
import { init as initEcImprPLV } from './../enhanced/ec-1-impression-plv2';
import { init as initEcCartCrossSell } from './../enhanced/ec-cart-cross-sell';

// ENHANCED E-COMMERCE : IMPRESSIONS
import {init as initListImpression } from './../enhanced/ec-impression-list';
import {init as initLvpImpression } from './../enhanced/ec-impression-lvp';
import {init as initSimilarImpression } from './../enhanced/ec-impression-similar';
import {init as initCrossSellImpression } from './../enhanced/ec-impression-cross-sell';
import {init as initSpotlightImpression } from './../enhanced/ec-impression-spotlight';
import {init as initSparepartImpression } from './../enhanced/ec-impression-sparepart';

if (window.cube.config.anly_useLegacy === 'Y') {
  // Analytics - Framework / Tracking
  require('./../analytics.entry');
} else {
  require('../transcript-workaround');
}

// Standalone Analytics Initialisation
export const init = () => {
  if ( window.cube.config.anly_useLegacy === 'Y') {
    //Init Utils
    initUtils();

    initEcImprPLV();

    // Init Trackers
    initHeader();
    initFooter();
    initFilters();
    // initNavigation();
    initSearch();
    initLvpHistory();
    initSmartSuggest();
    if ($('body').hasClass('our-suggestions-page')) initSuggestions();

    // Init Shopping Tool
    initStAddToCart();
    initStNavigation();
    initStBreadcrumb();
    initStOpeco();
    initStInternalSearch();

    // Init Enhanced e-Commerce
    // initEcImprPLV();
    initEcCartCrossSell();

    // Init Impressions
    initListImpression();
    initLvpImpression();
    initCrossSellImpression();
    initSimilarImpression();
    if (window.location.pathname.indexOf('/p-a/') > -1) {
      initSparepartImpression();
    } else {
      initSpotlightImpression();
    }

    if ($('body').hasClass('product-page')) initExpressCheckout();
    if (tc_vars.env_template === 'sport_page') initSportPage();
  }
};



// WEBPACK FOOTER //
// ./src/analytics/routes/common.anly.route.js